import { UnitTypesEnum } from "@propertelligent/client-api";
import { Blackbed, Blackshower, Blackvector, } from "../../../assets/index";
import ProgressBar from "../../../components/common/ProgressBar";
import StatusTag from "../../common/StatusTag";
import { getBathroomText } from "../../../constants/constants";
import { AvatarWithLoading } from "../../common/avator";
import EmptyData from "../../common/EmptyData";
import { getSizeString } from "../../../utils/helper";
import "./styles.css";
import { GetImages } from "../../../utils/GetImages";

export const ViewItem = ({ rows, loading, handleItemClick, handleInviteTenantClick, showTarget, notFoundPage = true }) => {
  function getKeyByValue(value: number): string | undefined {
    const keys = Object.keys(UnitTypesEnum).filter(
      (key) => UnitTypesEnum[key as keyof typeof UnitTypesEnum] === value
    );
    return keys.length > 0 ? keys[0] : undefined;
  }
  return (
    <>
      {(rows?.length == 0 && !loading) ? (
        notFoundPage &&
        <EmptyData
          mainText={"No Units Found"}
          subText={undefined}
          button={undefined}
          ImageSrc={GetImages.NoUnitFound}
        />
      ) :
        rows?.map((record) => (
          
          <div key={record?.id}
            className={"flexFullRow itemContainer"}
            onClick={() => handleItemClick(record?.id)}
          >
            <div className="flexColumn">
              <div className="flexFullRow">
                <div className="flexColumn itemContainerimg">
                  <AvatarWithLoading
                    docNumber={record?.mainImageId}
                    docImage={record?.mainImageBase64}
                    avatar={true}
                    Size="Icon40"
                  />
                </div>
                <div className="flexColumn itemContainerimgDetail">
                  <div className="flexFullRow title mb-1">
                    <span style={{ marginRight: 5 }}>{record?.unitNumber || "BG102"}</span>
                    {record?.tenantNames == null ?
                      <StatusTag color={"gray"} statusText={"Vacant"} isLarge={true} />
                      : null}
                    {record?.expensesDue > 0 ?
                      <StatusTag
                        color={"red"}
                        icon={<img src={GetImages.redArrow} />}
                        isLarge={false}
                        statusText={record?.formatted?.ExpensesDue ? `$ ${record?.formatted?.ExpensesDue} due ` : ""}
                      /> : null
                    }
                  </div>
                  <div className="flexFullRow">
                    <span className="featureType">
                      {getKeyByValue(record?.unitTypeId)}{" "}
                      {record?.tenantNames?.[0] && (
                        <span>{record?.tenantNames?.[0]}</span>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* End of first column */}
            <div className="unitNumberOfItem">
              {record?.unitTypeId === 1 ? (
                <>
                  <div className="feature">
                    <img src={Blackbed} />
                    <span className="sub_text grey_subtext1">
                      {record?.numberOfBedrooms}{" "}
                      {getBathroomText(record?.numberOfBedrooms, "Bedroom")}
                    </span>
                  </div>
                  <div className="dividerdiv"></div>
                  <div className="feature">
                    <img src={Blackshower} />
                    <span className="sub_text grey_subtext1">
                      {record?.numberOfBathrooms}{" "}
                      {getBathroomText(record?.numberOfBathrooms, "Bathroom")}
                    </span>
                  </div>
                </>
              ) : (
                <div className="feature">
                  <img src={Blackshower} />
                  <span className="sub_text grey_subtext1">
                    {record?.unitTypeId === UnitTypesEnum.Room ? (
                      record?.isBathAttached === true ? "Attached" : "Common"
                    ) : "Studio"}
                  </span>
                </div>
              )}
              <div className="dividerdiv"></div>
              <div className="feature">
                <img src={Blackvector} />
                <span className="sub_text grey_subtext1">
                  {getSizeString(record?.size)}
                </span>
              </div>
            </div>
            {/* End of 2nd column */}
            {showTarget &&
              <div className="unitListProgress" style={{ width: "20%" }}>
                {record?.leaseRemainingMonths !== null && record?.tenantIds !== null ? (
                  <ProgressBar monthsRemaining={record?.leaseRemainingMonths} leaseType={undefined} />
                ) : (
                  <div className="normal_text fw-600 blue">
                    <p onClick={handleInviteTenantClick}> + Add Tenant</p>
                  </div>
                )}
              </div>
            }
          </div>
        ))}
    </>
  );
};
